import * as Yup from "yup";
import { TFunction } from "i18next";

type Translator = (key: string, vars?: Record<string, any>) => string;

export default function savePtoSchema(t: TFunction | Translator) {
  return Yup.object().shape({
    start_date: Yup.date().required(
      t("Pto.validations.required", {
        value: t("Pto.start_date"),
      })
    ),

    end_date: Yup.date()
      .required(
        t("Pto.validations.required", {
          value: t("Pto.end_date"),
        })
      )
      .test(
        "is-after-start",
        t("Pto.validations.endDateMustBeAfterStart"),
        function (value) {
          const { start_date } = this.parent;
          if (!value || !start_date) return true;
          return value >= start_date;
        }
      ),

    hours_requested: Yup.number()
      .required(
        t("Pto.validations.required", {
          value: t("Pto.hours_requested"),
        })
      )
      .min(
        1,
        t("Pto.validations.decimalNum", {
          value: t("Pto.hours_requested"),
        })
      ),
  });
}
